import React, {Component, PropTypes} from 'react';
import {closeWindow} from './navHelpers';
import {Link} from 'react-router';
import ExternalLink from '../ExternalLink/ExternalLink.jsx';

class LeftNavButton extends Component {
	render() {
    const {
      salesSessionId,
      showCancelButton,
      backNavText,
      backNavDestination,
      backNavIsExternalDestination
		} = this.props;

		const renderBackNav = (isExternalDestination) => isExternalDestination ? externalBackNav : internalBackNav;
		const externalBackNav = (
			<ExternalLink data-tracking={JSON.stringify({backNavText})} href={backNavDestination}>
				<span className="polaris-xfinity-back x-body2">
					<span className="vh-small">{backNavText}</span>
				</span>
			</ExternalLink>
		);
		const internalBackNav = (
			<Link data-tracking={JSON.stringify({backNavText})} to={backNavDestination}>
				<span className="polaris-xfinity-back x-body2">
					<span className="vh-small">{backNavText}</span>
				</span>
			</Link>
		);

		const renderCancelButton = () => (
			<button className="x-button--text" data-tracking={{}} onClick={() => closeWindow({salesSessionId})}>
				<span className="polaris-xfinity-back--cancel x-body2">Cancel</span>
			</button>
		);

		return (
			<div>
				{(backNavDestination && !showCancelButton) && renderBackNav(backNavIsExternalDestination)}
				{showCancelButton && renderCancelButton()}
			</div>
		);
	}
}

LeftNavButton.propTypes = {
  salesSessionId: PropTypes.string,
  showCancelButton: PropTypes.bool.isRequired,
  backNavText: PropTypes.string,
  backNavDestination: PropTypes.string,
  backNavIsExternalDestination: PropTypes.bool
};

export default LeftNavButton;



/** WEBPACK FOOTER **
 ** ./client/components/Common/Nav/LeftNavButton.jsx
 **/